import formatDate from '@/services/general/formatDate';

export default function validation(i18n, errors, messages) {
  errors.forEach(e => {
    if (e.indexOf('JOURNAL_REQUIRED') === 0) {
      messages.push({
        message: 'validationEcriture.journalRequiered',
      });
    }
    if (e.indexOf('WORDING_REQUIRED') === 0) {
      messages.push({
        message: 'validationEcriture.wordingRequiered',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINES_COUNT_TOO_LOW') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinCouTooLow',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINES_CREDIIT_CUMUL_ZERO') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinCreCumZer',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINES_WITH_NEGATIVE_CREDIT') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinWitNegCre',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINES_IMBALANCE_AMOUNTS') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinImbAmo',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINES_DEBIT_CUMUL_ZERO') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinDebCumZer',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINES_WITH_NEGATIVE_DEBIT') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinWitNegDeb',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINES_REQUIRED') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinReq',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_LIST_NULL') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinLisNul',
      });
    }
    if (e.indexOf('MIN_POSTING_DATE_INVALID') === 0) {
      messages.push({
        message: 'validationEcriture.minPosDatInv',
      });
    }
    if (e.indexOf('POSTING_DATE_REQUIRED') === 0) {
      messages.push({
        message: 'validationEcriture.posDatReq',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_NULL') === 0) {
      messages.push({
        message: 'validationEcriture.accWriNul',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_REFERENCE_REQUIRED') === 0) {
      messages.push({
        message: 'validationEcriture.accWriRefReq',
      });
    }
    if (e.indexOf('COMPAGNY_ID_INVALID') === 0) {
      messages.push({
        message: 'validationEcriture.comIdInv',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_AUXILIARY_ACCOUNT_MISMATCH') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinAuxAccMis',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_ACCOUNT_NUMBER_REQUIRED') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinAccNumReq',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_ACCOUNT_NUMBER_IS_MISSING') === 0) {
      const params = e.split('|')[0].split('@');
      messages.push({
        message: 'validationEcriture.accWriLinAccNumIsMissingFromSchemaComptable',
        parametres: {
          schemaComptable: params[1],
        },
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_CREDIT_EQUAL_DEBIT') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinCreEquDeb',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_WORDING_REQUIRED') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinWorReq',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_BEGIN_DATE_NULL') === 0 && e.includes('begin')) {
      messages.push({
        message: 'validationEcriture.accWriLinBegDatNulConParDeb',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_BEGIN_DATE_NULL') === 0 && e.includes('end')) {
      messages.push({
        message: 'validationEcriture.accWriLinBegDatNulConParFin',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_BEGIN_DATE_NOT_NULL') === 0 && e.includes('begin')) {
      messages.push({
        message: 'validationEcriture.accWriLinBegDatNotNullTieDeb',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_BEGIN_DATE_NOT_NULL') === 0 && e.includes('end')) {
      messages.push({
        message: 'validationEcriture.accWriLinBegDatNotNullTieFin',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_BEGIN_DATE_NOT_NULL') === 0 && e.includes('begin')) {
      messages.push({
        message: 'validationEcriture.accWriLinBegDatNotNullTvaDeb',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_BEGIN_DATE_NOT_NULL') === 0 && e.includes('end')) {
      messages.push({
        message: 'validationEcriture.accWriLinBegDatNotNullTvaFin',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINE_NULL') === 0) {
      messages.push({
        message: 'validationEcriture.accWriLinNul',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_TYPE_REQUIRED') === 0) {
      messages.push({
        message: 'validationEcriture.accWriTypReq',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_REFERENCE_ID_REQUIRED') === 0) {
      messages.push({
        message: 'validationEcriture.accWriRefIdReq',
      });
    }
    if (e.indexOf('ACCOUNTING_WRITING_LINES_IMBALANCE_WITH_TTC_AMOUNTS') === 0) {
      messages.push({
        message: 'validationEcriture.cumulPasConforme',
      });
    }
    if (e.indexOf('NOT_MOST_RECENT_ACCOUNTING_WRITING') === 0) {
      messages.push({
        message: 'validationEcriture.ecriturePasRecente',
      });
    }
    if (e.indexOf('EXERCICE_PERIOD_NOT_FOUND') === 0) {
      const elements = e.split('|')[0].split('@');
      const dateEcriture = elements[1];
      messages.push({
        message: 'validationEcriture.exerciceAbsent',
        parametres: {
          param1: formatDate(dateEcriture),
        },
      });
    }
    if (e.indexOf('EXERCICE_PERIOD_NOT_ACTIVE') === 0) {
      const elements = e.split('|')[0].split('@');
      const dateEcriture = elements[1];
      messages.push({
        message: 'validationEcriture.exerciceInactif',
        parametres: {
          param1: formatDate(dateEcriture),
        },
      });
    }
    if (e.indexOf('EXERCICE_PERIOD_CLOSED') === 0) {
      const elements = e.split('|')[0].split('@');
      const dateEcriture = elements[1];
      messages.push({
        message: 'validationEcriture.exerciceClos',
        parametres: {
          param1: formatDate(dateEcriture),
        },
      });
    }
  });
}
